/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { loadFromLocalStorage } from '../common/localStorage';
import { fetchNotificationsEndpoint } from '../common/constants';
import { asApplicationJsonBody } from '../common/graphqlJsonBody';
const requestNotificationType = 'REQUEST_Notification';
const recieveNotificationType = 'RECEIVE_Notification';
const errorType = 'ERROR';
const recieveNotificationCountType = 'RecieveNotificationCountType';
const resetNotificationCountType = 'ResetNotificationCount';
const initialState = {
    data: {},
    isLoading: false
}

export const actionCreators = {
    getNotifications: (shouldLoad: boolean = true) => async (dispatch: any, getState: any) => {

        const token: string = loadFromLocalStorage('AuthToken');
        const encodedToken = 'Bearer ' + token;
        const headerDict: any = {
            'Authorization': encodedToken,
            'Content-Type': 'application/json'
        };
        const queryString = `query{ 
	notifications 
	{ 
		count 
		data { 
			bulletinNotification{
                title,
                message,
                createdDate,
				serviceBulletinNumber,
				description,
				url,
				notificationId,
                isViewed,
                isLimited
			}
		} 
	} 
}	`
        try {
            if (navigator.onLine) {
                if (shouldLoad) {
                    dispatch({ type: requestNotificationType });
                }
                const response = await fetch(fetchNotificationsEndpoint, {
                    headers: new Headers(headerDict),
                    body: asApplicationJsonBody(queryString),
                    method: 'POST'
                });
                const responseData = await response.json();
                dispatch({ type: recieveNotificationType, responseData });
            }
        } catch (e) {
            if (navigator.onLine) {
                dispatch({ type: errorType, e });
            }
        }
        return;
    },
    getNotificationCount: () => async (dispatch: any, getState: any) => {
        const token: string = await loadFromLocalStorage('AuthToken');
        if (token != undefined) {
            let encodedToken = 'Bearer ' + token;
            const headerDict: any = {
                'Authorization': encodedToken,
                'Content-Type': 'application/json'
            };
            const queryString = `query{ 
	notifications 
	{ 
		count 
	} 
}	`
            try {
                if (navigator.onLine) {
                    const response = await fetch(fetchNotificationsEndpoint, {
                        headers: new Headers(headerDict),
                        body: asApplicationJsonBody(queryString),
                        method: 'POST'
                    });
                    const responseData = await response.json();
                    dispatch({ type: recieveNotificationCountType, responseData });
                }
            } catch (e) {
                console.log(e);
                if (navigator.onLine) {
                    dispatch({ type: errorType, e });
                }
            }
        }
        return;
    },
    resetNotificationCount: () => async (dispatch: any, getState: any) => {
        dispatch({ type: resetNotificationCountType });
    }
}

export const reducer = (state: any, action: any) => {
    state = state || initialState;

    switch (action.type) {
        case requestNotificationType:
            return {
                ...state,
                isLoading: true
            };
        case recieveNotificationType:
            return {
                ...state,
                data: action.responseData.data.notifications.data,
                totalCount: action.responseData.data.notifications.count,
                isLoading: false
            };

        case errorType:
            return {
                ...state,
                isLoading: false,
                error: action.e
            };
        case recieveNotificationCountType:
            return {
                ...state,
                totalCount: action.responseData.data.notifications.count
            };
        case resetNotificationCountType:
            return {
                ...state,
                totalCount: undefined
            };

    }
    return state;
};
